import '../../style/index.less';
import './index.less';
// style dependencies
import '../../select/style';
import '../../checkbox/style';



// WEBPACK FOOTER //
// ./components/tree-select/style/index.tsx